import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useSelector, useDispatch } from 'react-redux';
import actions from '../../store/actions';
import ResponsivePagination from 'react-responsive-pagination';
import productApi from '../../api/product';
import moment from 'moment';
import routes from "../../utils/routes";
import UpdateOrder from '../../components/forms/updateOrder';



let Users = () => {
   const [currentPage, setCurrentPage] = useState(1);
   let navigate = useNavigate();
   let users = useSelector(data => data.users);
   let dispatch = useDispatch();
   useEffect(() => {
      setCurrentPage(users?.data?.page)
      // if (orders?.page != 1) {// to reset the data 
      //    getOrdersList(1);
      // }
   }, [])

   const getUsersList = (page) => {
      try {
         dispatch(actions.usersLoading());
         productApi.getUsers(page).then(async res => {
            if (res?.data?.data) {
               dispatch(actions.addUsersList({
                  data: res?.data?.data?.data,
                  page: res?.data?.data?.page,
                  limit: res?.data?.data?.perPage,
                  totalPages: res?.data?.data?.totalPages,
                  total: res?.data?.data?.total
               }));
               setCurrentPage(res?.data?.data?.page)
            }
         })
      } catch (error) {
         console.log("brands getting error", error.message)
      }
   }




   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>User Management</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="card p-3 dashboard-card">
                        <div className="card-heading text-muted">Users ({users?.data?.total})</div>
                        {users.loading ? (
                           <div className='pageSimpleLoader'>
                              {users.loading ? "Loading..." : "No record found"}
                           </div>
                        ) : (
                           <>
                              <div className="table-responsive">
                                 <table className='table'>
                                    <thead>
                                       <tr>
                                          <th>#</th>
                                          <th>Email</th>
                                          <th>Name</th>
                                          <th>Phone Number</th>
                                          <th>City</th>
                                          <th>Status</th>
                                          <th>Created At</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {users?.data?.data?.map((data, index) => {
                                          const startItemNumber = (currentPage - 1) * 10;
                                          return (
                                             <tr key={index}>
                                                <td>{startItemNumber + index + 1}</td>
                                                <td>{data?.email}</td>
                                                <td>{data?.name}</td>
                                                <td>{data.phoneNumber}</td>
                                                <td>{data?.city}</td>
                                                <td>
                                                   {data?.verified ? <span className="badge bg-success">Verified</span> : <span className="badge bg-danger">Unverified</span>}
                                                </td>
                                                <td>{moment(data.createdAt).fromNow()}</td>
                                                <td><button className='btn bg-black text-white text-small'
                                                   onClick={() => {
                                                      navigate(routes?.userDetails(data?._id))
                                                   }}
                                                > <small>View</small> </button></td>
                                             </tr>
                                          )
                                       })}
                                       {users?.data?.length == 0 && (
                                          <td colSpan={8} className='text-center py-5'>
                                             {users.loading ? "Loading..." : "No record found"}
                                          </td>
                                       )}
                                    </tbody>
                                 </table>
                              </div>
                              <ResponsivePagination
                                 current={Number(users?.data?.page)}
                                 total={users?.data?.totalPages || 0}
                                 onPageChange={getUsersList}
                              />
                           </>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </DashboardLayout>
      </>
   )
}

export default Users